export const en = {
  misc: {
    locale: {
      box: {
        title: {country: 'Select language'},
      },
    },
    storeName: 'AS Roma',
  },
  welcome: 'Welcome to AS Roma',
};
